import { Box, Typography } from "@mui/material"

import probiotics from "static/images/news/probiotics.png"
import seed_oil from "static/images/news/seed_oil.png"
import useTranslation from "hooks/use_translation"

import NewsItem from "./Card"

const News = () => {
  const { pages } = useTranslation()
  const posts = [
    {
      title: "Probiotics for Weight Loss: Separating Fact From Fiction",
      description:
        "With growing levels of obesity internationally, largely due to the widespread adoption of the Western diet, it is no surprise that researchers worldwide have been exploring",
      created_at: "March 12, 2025",
      src: probiotics,
    },

    {
      title: "Seed Oils and Beef Tallow: Dietitians Compare",
      description:
        "At a time when seed oils are being villainized, and beef tallow is being praised, dietitians weigh in on the real risks and concerns associated with these fats.",
      created_at: "March 12, 2025",
      src: seed_oil,
    },
  ]

  return (
    <Box sx={{ backgroundColor: "bg.light", width: "100%" }}>
      <Typography variant="h5" sx={{ mb: 2.5 }}>
        {pages?.client_main?.news_title}
      </Typography>
      {posts.map((post, i) => (
        <NewsItem key={i} {...post} />
      ))}
    </Box>
  )
}

export default News
